/* eslint-disable prettier/prettier */
// eslint-disable-next-line sonarjs/no-duplicate-string

import { sanitizeURL } from '../utils/utils';

export interface ApiUrls {
  readonly container: string;
  readonly micro: string;
  readonly customers?: string;
  readonly inprogress: string;
  readonly paymentalb: string;
  readonly dashboard_apiurl: string;
  readonly agreements: string;
  readonly coworker: string;
  readonly menu: string;
  readonly am: string;
  readonly cashmgmt:string;
  readonly inventory:string;
}

export interface AppConfigItem {
  readonly apiUrls: ApiUrls;
  readonly microUrl: string;
  readonly auth: {
    readonly region: string;
    readonly userPoolId: string;
    readonly userPoolWebClientId: string;
    readonly oauth: {
      readonly domain: string;
      readonly scope?: string[];
      readonly redirectSignIn: string;
      readonly redirectSignOut: string;
      readonly responseType: string;
      readonly urlOpener: (url: string) => void;
    };
  };
}

const microUrl = {
  localhost: 'http://localhost:3006',
  local: 'https://local-placeholder-racpad.rentacenter.com',
  dev: 'https://dev-placeholder-racpad.rentacenter.com',
  qa: 'https://qa-placeholder-racpad.rentacenter.com',
  uat: 'https://uat-placeholder-racpad.rentacenter.com',
  prod: 'https://racpad-placeholder.rentacenter.com',
};

export interface AppConfig extends AppConfigItem {
  readonly appName: string;
}

export const urlOpener = (url: string): void => {
  const urlToOpen = sanitizeURL(url);

  if (urlToOpen) {
    window.open(urlToOpen, '_self');
  }
};

export const localhost: AppConfigItem = {
  apiUrls: {
    container: 'https://local-racpad.rentacenter.com/api',
    micro: 'https://local-placeholder-racpad.rentacenter.com/api',
    am:'https://local-am-racpad.rentacenter.com/api',
    cashmgmt:'https://local-cashmgmt-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    customers: 'https://local-customer-racpad.rentacenter.com/api',
    dashboard_apiurl: "https://local-dashboard-racpad.rentacenter.com/api",
    // eslint-disable-next-line sonarjs/no-duplicate-string
    paymentalb:'https://local-payment1-lb-racpad.rentacenter.com',
    inprogress: 'https://local-payment1-racpad.rentacenter.com/api',
    agreements: 'https://local-agreement-racpad.rentacenter.com/api',
    coworker: 'https://local-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://local-menu-racpad.rentacenter.com/api',
    inventory:'https://local-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.localhost,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FPWut7aB',
    userPoolWebClientId: '608s8dso4aecka8omjpukssq3n',
    oauth: {
      domain: 'auth-local-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.localhost,
      redirectSignOut: microUrl.localhost,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const localhostIE11: AppConfigItem = { ...localhost };

export const local: AppConfigItem = {
  apiUrls: {
    container: 'https://local-racpad.rentacenter.com/api',
    micro: 'https://local-placeholder-racpad.rentacenter.com/api',
    customers: 'https://local-customer-racpad.rentacenter.com/api',
    inprogress: 'https://local-payment1-racpad.rentacenter.com/api',
    dashboard_apiurl: "https://dev-dashboard-racpad.rentacenter.com/api",
    cashmgmt:'https://dev-cashmgmt-racpad.rentacenter.com/api',
    am:'https://dev-am-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    paymentalb:'https://local-payment1-lb-racpad.rentacenter.com',
    agreements: 'https://local-agreement-racpad.rentacenter.com/api',
    coworker: 'https://local-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://local-menu-racpad.rentacenter.com/api',
    inventory:'https://local-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.local,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FPWut7aB',
    userPoolWebClientId: '608s8dso4aecka8omjpukssq3n',
    oauth: {
      domain: 'auth-local-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.local,
      redirectSignOut: microUrl.local,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const dev: AppConfigItem = {
  apiUrls: {
    container: 'https://dev-racpad.rentacenter.com/api',
    micro: 'https://dev-placeholder-racpad.rentacenter.com/api',
    customers: 'https://dev-customer-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    inprogress: 'https://dev-payment1-racpad.rentacenter.com/api',
    dashboard_apiurl: "https://dev-dashboard-racpad.rentacenter.com/api",
    am:'https://dev-am-racpad.rentacenter.com/api',
    cashmgmt:'https://dev-cashmgmt-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    paymentalb:'https://dev-payment1-lb-racpad.rentacenter.com',
    agreements: 'https://dev-agreement-racpad.rentacenter.com/api',
    coworker: 'https://dev-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://dev-menu-racpad.rentacenter.com/api',
    inventory:'https://dev-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.dev,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_IX7X5lZqL',
    userPoolWebClientId: '4o7nqktg06c45g59dqhd51gik5',
    oauth: {
      domain: 'auth-dev-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.dev,
      redirectSignOut: microUrl.dev,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const qa: AppConfigItem = {
  apiUrls: {
    container: 'https://qa-racpad.rentacenter.com/api',
    micro: 'https://qa-placeholder-racpad.rentacenter.com/api',
    customers: 'https://qa-customer-racpad.rentacenter.com/api',
    inprogress: 'https://qa-payment1-racpad.rentacenter.com/api',
    dashboard_apiurl: "https://qa-dashboard-racpad.rentacenter.com/api",
    am:'https://qa-am-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    paymentalb:'https://qa-payment1-lb-racpad.rentacenter.com',
    agreements: 'https://qa-agreement-racpad.rentacenter.com/api',
    coworker: 'https://qa-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://qa-menu-racpad.rentacenter.com/api',
    cashmgmt:'https://qa-cashmgmt-racpad.rentacenter.com/api',
    inventory:'https://qa-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.qa,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_8MbOyEYG6',
    userPoolWebClientId: '47r2ihk9fehcpn9t64thdbu2tl',
    oauth: {
      domain: 'auth-qa-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.qa,
      redirectSignOut: microUrl.qa,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const uat: AppConfigItem = {
  apiUrls: {
    container: 'https://uat-racpad.rentacenter.com/api',
    micro: 'https://uat-placeholder-racpad.rentacenter.com/api',
    customers: 'https://uat-customer-racpad.rentacenter.com/api',
    am:'https://uat-am-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    inprogress: 'https://uat-payment1-racpad.rentacenter.com/api',
    dashboard_apiurl: "https://uat-dashboard-racpad.rentacenter.com/api",
    paymentalb:'https://uat-payment1-lb-racpad.rentacenter.com',
    agreements: 'https://uat-agreement-racpad.rentacenter.com/api',
    coworker: 'https://uat-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://uat-menu-racpad.rentacenter.com/api',
    cashmgmt:'https://uat-cashmgmt-racpad.rentacenter.com/api',
    inventory:'https://uat-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.uat,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FBmCthpda',
    userPoolWebClientId: '1d8vgr67fr7gli9abpv9j1cb3n',
    oauth: {
      domain: 'auth-uat-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.uat,
      redirectSignOut: microUrl.uat,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const prod: AppConfigItem = {
  apiUrls: {
    container: 'https://racpad.rentacenter.com/api',
    micro: 'https://racpad-placeholder.rentacenter.com/api',
    customers: 'https://racpad-customer.rentacenter.com/api',
    inprogress: 'https://prod-payment1-racpad.rentacenter.com/api',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    paymentalb:'https://prod-payment1-lb-racpad.rentacenter.com',
    dashboard_apiurl: "https://prod-dashboard-racpad.rentacenter.com/api",
    agreements: 'https://prod-agreement-racpad.rentacenter.com/api',
    coworker: 'https://prod-storemgmt-racpad.rentacenter.com/api',
    menu: 'https://prod-menu-racpad.rentacenter.com/api',
    am:'https://prod-am-racpad.rentacenter.com/api',
    cashmgmt:'https://prod-cashmgmt-racpad.rentacenter.com/api',
    inventory:'https://prod-inventory-racpad.rentacenter.com/api'
  },
  microUrl: microUrl.prod,
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_so5RR57Of',
    userPoolWebClientId: '50nk6ibf5lru47hesk4j0cfuu4',
    oauth: {
      domain: 'auth-racpad.auth.us-east-1.amazoncognito.com',
      redirectSignIn: microUrl.prod,
      redirectSignOut: microUrl.prod,
      responseType: 'token',
      urlOpener,
    },
  },
};

export const artifact: AppConfigItem = {
  apiUrls: {
    container: '_apiUrls.container',
    micro: '_apiUrls.micro',
    customers: '_apiUrls.customer',
    inprogress: '_apiUrls.payment',
    paymentalb: '_apiUrls.paymentAlb',
    dashboard_apiurl : '_apiUrls.dashboard',
    agreements: '_apiUrls.agreement',
    coworker: '_apiUrls.coworker',
    menu: '_apiUrls.menu',
    am: '_apiUrls.am',
    cashmgmt: '_apiUrls.cashmgmt',
    inventory:'_apiUrls.inventory'
  },
  microUrl: '_microUrl',
  auth: {
    region: '_auth.region',
    userPoolId: '_auth.userPoolId',
    userPoolWebClientId: '_auth.userPoolWebClientId',
    oauth: {
      domain: '_auth.oauth.domain',
      redirectSignIn: '_auth.oauth.redirectSignIn',
      redirectSignOut: '_auth.oauth.redirectSignOut',
      responseType: '_auth.oauth.responseType',
      urlOpener,
    },
  },
};

let appConfigItem: AppConfigItem;

switch (process.env.REACT_APP_STAGE) {
  case 'localhost':
    appConfigItem = localhost;
    break;
  case 'localhost-ie11':
    appConfigItem = localhostIE11;
    break;
  case 'local':
    appConfigItem = local;
    break;
  case 'dev':
    appConfigItem = dev;
    break;
  case 'qa':
    appConfigItem = qa;
    break;
  case 'uat':
    appConfigItem = uat;
    break;
  case 'prod':
    appConfigItem = prod;
    break;
  case 'artifact':
    appConfigItem = artifact;
    break;
  default:
    appConfigItem = localhost;
    break;
}

export const appConfig: AppConfig = {
  appName: 'Placeholder',
  ...appConfigItem,
};
